import { createSelector } from 'reselect';

import {
  AUTHENTICATED_USER_ACCESS,
  FAVORITES,
  PERSONAL_ARCHIVE_WRITE,
  SHARED_LIBRARY_WRITE,
  TEAM_ARCHIVE_WRITE,
  VIDEO_TOOLS_ACCESS,
} from 'constants/scopes';

import { selectUserScopes } from './scopes';

export const selectOverflowMenuScopes = createSelector(
  selectUserScopes,
  scopes => ({
    hasAuthenticatedAccess: scopes.includes(AUTHENTICATED_USER_ACCESS),
    hasFavoritesScope: scopes.includes(FAVORITES),
    hasPersonalArchiveWriteScope: scopes.includes(PERSONAL_ARCHIVE_WRITE),
    hasSharedLibraryWriteScope: scopes.includes(SHARED_LIBRARY_WRITE),
    hasTeamArchiveWriteScope: scopes.includes(TEAM_ARCHIVE_WRITE),
    hasVideoToolsAccessScope: scopes.includes(VIDEO_TOOLS_ACCESS),
  })
);
